import { IUserRole } from '../models/user-roles.model';

/**
 * Whether the user holds `role` on `module`, e.g. `admin` on `analytics`.
 *
 * Roles come off the Cognito `custom:roles` attribute, whose casing is set by whoever
 * administered the user, so both the module and the role are compared case-insensitively.
 * A user with no roles yet has `undefined` here, which is treated as "no".
 */
export function hasModuleRole(roles: Array<IUserRole>, module: string, role: string): boolean {
    return (roles ?? []).some(
        (entry: IUserRole) =>
            entry?.module?.toLowerCase() === module.toLowerCase() &&
            (entry.roles ?? []).some((entryRole: string) => entryRole?.toLowerCase() === role.toLowerCase())
    );
}
